import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';

const translateRight = (translateXPercent: number) =>
  keyframes`0%{ 
    opacity: 0 ;
    transform: translateX(${translateXPercent}%);

 }
 100% {
    opacity: 1;
    transform: translateX(0);
 }
`;

const translateLeft = (translateXValue: number) =>
  keyframes`0%{ 
    opacity: 0;
      transform: translateX(-${translateXValue}%);
  
   }
   100% {
    opacity: 1;
      transform: translateX(0);
   }
  `;

export const PanAnimation = styled.div<{
  speed: number;
  direction: string;
  delay: number;
  easeFunction: string;
  translateXPercent: number;
}>`
  ${(props) =>
    props.direction === 'right' &&
    css`
      animation: ${translateRight(props.translateXPercent)} ${props.speed}s ${props.delay}s
        ${props.easeFunction};
    `}
  ${(props) =>
    props.direction === 'left' &&
    css`
      animation: ${translateLeft(props.translateXPercent)} ${props.speed}s ${props.delay}s
        ${props.easeFunction};
    `}
`;

export const PanNavAnimation = styled.div<{
  speed: number;
  navAnimationSpeed: number;
  translateXPercent: number;
  easeFunction: string;
}>`
  ul > {
    &:nth-of-type(1) {
      animation: ${(props) => translateLeft(props.translateXPercent)} ${(props) => props.speed}s
        ${(props) => props.easeFunction};
    }
    &:nth-of-type(2) {
      animation: ${(props) => translateLeft(props.translateXPercent + 5)} ${(props) => props.speed}s
        ${(props) => props.easeFunction};
    }
    &:nth-of-type(3) {
      animation: ${(props) => translateLeft(props.translateXPercent + 10)}
        ${(props) => props.speed}s ${(props) => props.easeFunction};
    }
    &:nth-of-type(4) {
      animation: ${(props) => translateLeft(props.translateXPercent + 15)}
        ${(props) => props.speed}s ${(props) => props.easeFunction};
    }
    &:nth-of-type(5) {
      animation: ${(props) => translateLeft(props.translateXPercent + 20)}
        ${(props) => props.speed}s ${(props) => props.easeFunction};
    }
    &:nth-of-type(6) {
      animation: ${(props) => translateLeft(props.translateXPercent + 25)}
        ${(props) => props.speed}s ${(props) => props.easeFunction};
    }
    &:nth-of-type(7) {
      animation: ${(props) => translateLeft(props.translateXPercent + 30)}
        ${(props) => props.speed}s ${(props) => props.easeFunction};
    }
    &:nth-of-type(8) {
      animation: ${(props) => translateLeft(props.translateXPercent + 40)}
        ${(props) => props.speed}s ${(props) => props.easeFunction};
    }
    &:nth-of-type(9) {
      animation: ${(props) => translateLeft(props.translateXPercent + 45)}
        ${(props) => props.speed}s ${(props) => props.easeFunction};
    }
  }
`;
